const fa = {
  onboarding: {
    countryQuestion: "متوجه شدم! 🌍\n\nدر کدام کشور هستید؟",
    countryPlaceholder: "در کدام کشور هستید؟",
    letsGo: "بزن بریم!",
    summaryIntro: "🎉 عالی، {name}! همه چیز آماده است!",
    yourNameLabel: "نام شما",
    baseLanguageLabel: "زبان پایه",
    goalsHint: "می‌توانید هدف واژگان و مدت دوره را هر زمان از صفحه اهداف تنظیم کنید.",
    startLearning: "شروع یادگیری {destLang}!",
  },
  header: {
    learner: "یادگیرنده",
    home: "🏠 خانه",
    allLessons: "📚 همه درس‌ها",
    currentLesson: "📖 درس فعلی",
    flashcards: "🃏 فلش‌کارت‌ها",
    progress: "📈 پیشرفت",
    goals: "🎯 اهداف",
    grammarLab: "📘 دستور زبان",
    more: "⋯ بیشتر",
    myVocabulary: "📝 واژگان من",
    listenSpeak: "🎧 گوش کن و صحبت کن",
    signOut: "↩ خروج",
  },
  lab: {
    title: "آزمایشگاه گوش کن و صحبت کن",
    back: "بازگشت",
    intro: "درباره موضوعی که قبلاً مطالعه کرده‌ای یک گفت‌وگوی گفتاری کوتاه با بابی داشته باش.",
    pickTopic: "موضوعی را که تمام کرده‌ای انتخاب کن",
    noTopics: "اول یک درس را کامل کن، سپس برای تمرین صحبت‌کردن به اینجا برگرد.",
    level: "سطح {level}",
    talkAbout: "درباره «{topic}» با بابی صحبت کن",
    speedLabel: "سرعت بابی",
    speedNormal: "معمولی",
    speedSlow: "آهسته",
    speedNote: "سرعت آهسته برای همان پاسخ، دقیقه‌های صوتی بیشتری مصرف می‌کند.",
    startConversation: "شروع گفت‌وگو",
    tapToStart: "روی میکروفون بزن و به ترکی به بابی پاسخ بده.",
    continueConversation: "به سؤال پاسخ دهید",
    finishSession: "پایان دادن",
    voiceReviewHint: "چیزی را که گفتی بررسی کن و تأیید کن — یا دوباره بگو.",
    voiceConfirm: "تأیید",
    voiceRedo: "دوباره",
    voiceDenied: "بدون دسترسی به میکروفون، صدا در دسترس نیست. هر زمان خواستید روی نماد میکروفون ضربه بزنید تا دوباره امتحان کنید.",
    lowBalanceWarning: "دقیقه‌های صوتی شما برای این دورهٔ ماهانه رو به اتمام است.",
    thinking: "بابی در حال فکر کردن است…",
    complete: "جلسه تمام شد",
    completeSub: "تمرین خوبی بود. هر وقت خواستی برای صحبت درباره‌ی موضوعی دیگر برگرد.",
    another: "تمرین موضوعی دیگر",
    done: "تمام",
    replyError: "بابی الان نتوانست پاسخ دهد. لطفاً چند لحظه دیگر دوباره امتحان کن.",
    tryAgain: "دوباره امتحان کن",
    eliteUpsellTitle: "گوش کن و صحبت کن یک ویژگی Elite است",
    eliteUpsellBody: "شما در طرح Pro هستید. برای تمرین صحبت با بابی، در تنظیمات به Elite ارتقا دهید.",
    listenAgainButton: "دوباره گوش بده",
    listenAgainPlaying: "توقف",
    translateButton: "ترجمه",
    translating: "در حال ترجمه…",
    translateFailed: "ترجمه ناموفق بود — دوباره امتحان کن.",
    starsAriaLabel: "{stars} از 3",
    explainButton: "توضیح بیشتر",
    explaining: "در حال توضیح…",
    explainFailed: "توضیح دریافت نشد — دوباره امتحان کن.",
    recapHeading: "گزارش مکالمه",
    recapTitle: "خلاصه‌ی شما",
    recapAvgStars: "میانگین این جلسه",
    recapTurnsCompleted: "{completed} از {total} نوبت کامل شد",
    recapErrorFree: "{n} نوبت بدون خطا",
    recapMistakesByType: "خطاها بر اساس نوع",
    recapCorrections: "آنچه اصلاح شد",
    voiceMinutesTitle: "زمان گفتگوی صوتی",
    voiceMinutesLeft: "{amount} از {total} در این دوره باقی مانده",
    voiceMinutesNone: "دقیقه‌ی ماهانه‌ای برای این دوره باقی نمانده",
  },
  dashboard: {
    greeting: "سلام، {name}! 👋",
    streakMsg: "زنجیره {streak} روزه 🔥 — ادامه بده!",
    noStreak: "امروز اولین درست رو شروع کن!",
    streakProtectionDays: "{n} روز محافظ استریک کسب شده 🛡️",
    dayInfo: "زبان پایه: {lang} · روز {day} از {total}",
    dayStreak: "روز متوالی",
    share: "اشتراک‌گذاری",
    wordsLearned: "کلمات یاد گرفته",
    lessonsDone: "درس‌های انجام‌شده",
    goalComplete: "هدف کامل‌شده",
    timeStudied: "زمان مطالعه",
    hoursUnit: "ساعت",
    paceTitle: "📊 ردیاب پیشرفت روزانه",
    statusAhead: "🚀 {delta} کلمه جلوتر!",
    statusBehind: "⚡ {delta} کلمه برای جبران",
    statusOnTrack: "✅ دقیقاً در مسیر!",
    paceTarget: "هدف: {wpd} کلمه/روز · امروز: {today} کلمه",
    paceExpected: "انتظار: {n}",
    paceGoal: "هدف: {n}",
    actionCurrentLesson: "درس فعلی",
    actionAllLessons: "همه درس‌ها",
    actionFlashcards: "فلش‌کارت‌ها",
    actionProgress: "پیشرفت من",
    actionGoals: "اهداف من",
    actionMyVocabulary: "واژگان من",
    actionGrammarLab: "آزمایشگاه دستور زبان",
    actionListenSpeak: "آزمایشگاه گوش کن و صحبت کن",
    lessonsSub: "{count} موضوع · {words} کلمه",
    cardsDue: "{n} کارت برای امروز!",
    allCaughtUp: "همه مرور شد! 🎉",
    progressSub: "نمودارها، دقت، رشد واژگان",
    myVocabSub: "همه کلماتی که یاد گرفته‌ای را مرور کن",
    listenSpeakSub: "با بابی تمرین صحبت کن",
    goalsSub: "{words} کلمه · {days} روز",
    apiCost: "💰 ردیاب هزینه API",
    since: "از {date}",
    resetBtn: "↺ بازنشانی",
    totalTokens: "کل توکن‌ها",
    inputTokens: "ورودی",
    outputTokens: "خروجی",
    estCost: "هزینه تقریبی",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "نکته:",
    tips: [
      "در ترکی، فعل همیشه در پایان جمله می‌آید — «Ben kahve içiyorum» یعنی «من قهوه می‌نوشم.» فقط الگوها را جذب کن!",
      "ترکی از هماهنگی واکه استفاده می‌کند — پسوندها واکه‌هایشان را با آخرین واکه ریشه تطبیق می‌دهند (مثلاً -lar/-ler، -da/-de). وقتی متوجه‌اش شوی، همه چیز سر جایش می‌افتد!",
      "ترکی هیچ جنس دستوری ندارد. نه اسم مذکر و نه مؤنث — یک چیز کمتر برای حفظ کردن نسبت به فرانسه، اسپانیایی یا آلمانی!",
      "ضمایر شخصی (ben = من، sen = تو) معمولاً در ترکی حذف می‌شوند چون پسوند فعل از قبل نشان می‌دهد چه کسی عمل می‌کند.",
      "ترکی از نظر آوایی منظم است — هر حرف همیشه به یک شکل خوانده می‌شود. آنچه می‌خوانی دقیقاً همان چیزی است که می‌گویی.",
      "نفی با افزودن -me/-ma مستقیماً بعد از ریشه فعل ساخته می‌شود: gel (بیا) ← gelme (نیا)، anla (بفهم) ← anlama.",
      "ترکی از حروف اضافه پسین استفاده می‌کند که بعد از اسم می‌آیند: «İstanbul'da» = «در استانبول» (استانبول + پسوند مکانی -da).",
      "پسوند جمع از هماهنگی واکه پیروی می‌کند: -lar بعد از واکه‌های خلفی (a, ı, o, u) و -ler بعد از واکه‌های پیشین (e, i, ö, ü). Akşam ← akşamlar، gece ← geceler.",
      "پسوند -ıyor/-iyor/-uyor/-üyor زمان حال استمراری را نشان می‌دهد. Anlıyorum = دارم می‌فهمم (anla + ıyor + um).",
      "افعال مرکب ترکی یک اسم را با etmek (کردن) یا olmak (بودن) ترکیب می‌کنند: teşekkür etmek (تشکر کردن)، hazır olmak (آماده بودن).",
    ],
  },
  lesson: {
    backBtn: "→ برگشت",
    topicOf: "موضوع {order} از {total} · {words} کلمه",
    translating: "در حال آماده‌سازی درس…",
    newWords: "✨ کلمات جدید ({n})",
    alreadyLearned: "🔄 قبلاً یاد گرفته ({n})",
    practiceDialogue: "🎭 تمرین",
    generateDialogue: "🎭 یک دیالوگ تمرینی بده",
    listenSpeakPractice: "🎧 تمرین در آزمایشگاه گوش کن و صحبت کن",
    generatingDialogue: "بابی داره دیالوگ رو آماده می‌کنه…",
    newDialogue: "↺ دیالوگ جدید",
    lessonSaved: "🎉 درس ذخیره شد! در حال افزودن {n} فلش‌کارت جدید…",
    alreadyTaken: "✅ درس قبلاً گذرانده شده",
    markComplete: "✅ درس رو کامل کن و فلش‌کارت‌ها رو ذخیره کن",
    wordProgress: "کلمه {current} از {total}",
    nextWord: "کلمه بعدی",
    previousWord: "قبلی",
  },
  vocab: {
    structure: "ساختار",
    loadingExample: "در حال بارگذاری…",
    limitReached: "↺ محدودیت رسید",
    anotherLeft: "↺ یکی دیگه ({n} باقی)",
    anotherExample: "↺ مثال دیگه",
    analyzing: "در حال تحلیل…",
    analyzed: "✓ تحلیل شد",
    analyzeWord: "🔍 تحلیل کلمه",
    analysisIntro: "در اینجا تحلیل گام‌به‌گام دستوری آمده است:",
    analysisError: "تحلیل بارگذاری نشد. لطفاً دوباره امتحان کنید.",
    reportMistake: "🚩 گزارش اشتباه",
    reportWrongMeaning: "معنی کلمه اشتباه است",
    reportWrongSentence: "معنی جمله اشتباه است",
    reportOther: "سایر",
    reportChecking: "در حال بررسی…",
    reportThanks: "✓ ممنون که به بهبود ما کمک کردید!",
    reportNoIssue: [
      "نتونستم مشکلی پیدا کنم — این به نظرم درست میاد!",
      "اینجا مشکلی نمی‌بینم — به نظرم درسته.",
      "از نظر من همه‌چیز درسته.",
      "مشکلی پیدا نکردم؛ همون‌طور که نوشته شده درست به نظر میاد.",
      "به نظرم خوبه — نگرانی خاصی ندارم.",
      "بررسی کردم و چیزی که نیاز به تغییر داشته باشه پیدا نکردم.",
      "مشکلی به چشمم نخورد؛ ترجمه درست به نظر میاد.",
      "تا جایی که من می‌بینم، همه‌چیز درسته.",
      "نتونستم مشکلی پیدا کنم؛ به نظرم خوبه.",
    ],
    reportCheckError: "در انجام بررسی مشکلی پیش اومد. لطفاً بعداً دوباره امتحان کنید.",
    reportOkBtn: "باشه، متوجه شدم",
    reportEscalateBtn: "ارجاع به یک بازبین انسانی",
    reportEscalatedMsg: "✓ برای تیم بازبینی ما ارسال شد. متشکریم!",
    reportAlreadyFlaggedMsg: "✓ این مورد قبلاً به تیم بازبینی ما گزارش شده است. متشکریم!",
  },
  allLessons: {
    title: "📚 همه درس‌ها",
    subtitle: "{count} موضوع · {words} کلمه",
    searchPlaceholder: "🔍 جستجوی موضوع یا کلمه…",
    noResults: "هیچ موضوعی با «{search}» مطابقت ندارد",
    overwhelmedBanner: "شما {n} کارت برای مرور دارید. لطفاً قبل از شروع درس‌های جدید، فلش‌کارت‌هایتان را مرور کنید.",
    overwhelmedLock: "ابتدا فلش‌کارت‌ها را مرور کنید",
    overwhelmedBtn: "رفتن به فلش‌کارت‌ها →",
  },
  flashcards: {
    title: "فلش‌کارت‌ها",
    cardOf: "کارت {current} از {total}",
    tapToReveal: "برای نمایش روی کارت بزن",
    hearIt: "🔊 بشنو",
    hearSentence: "🔊 جمله را بشنو.",
    allConsolidated: "همه تثبیت شده",
    noDue: "هیچ کارتی برای مرور وجود ندارد.\nحافظه‌ات خوب استراحت کرده.",
    backToDashboard: "برگشت به داشبورد",
    sessionComplete: "جلسه کامل شد",
    memoryRetention: "کارایی حافظه",
    forgotten: "فراموش شده",
    struggled: "سخت بود",
    recalled: "به یاد آوردم",
    effortless: "راحت بود",
    wordsConsolidated: "{retained} از {total} کلمه تثبیت شد",
    wordsInProgress: "{retained} از {total} کلمه در حال یادگیری",
    saveContinue: "ذخیره و ادامه",
    tomorrow: "فردا",
    nDays: "{n} روز",
    d1Title: "درک مطلب",
    d1SubSkill: "برای بهبود مهارت خواندن و شنیدن",
    d1Journey: "کلمات جدید سفرشان را از اینجا شروع می‌کنند.",
    d1Due: "{n} برای مرور",
    d1Listen: "بشنو",
    d1ShowWord: "کلمه را نشان بده",
    d2Title: "تولید",
    d2SubSkill: "برای بهبود مهارت صحبت و نوشتن",
    d2WillStart: "بعداً شروع می‌شود",
    d2Empty: "کلمات پس از تسلط در قسمت درک مطلب به اینجا می‌رسند.",
    d2ModalTitle: "تمرین تولید باز شد!",
    d2ModalBody: "اینها کلماتی هستند که از قبل خوب می‌شناسی. حالا تمرین می‌کنیم که آن‌ها را تولید کنی — این‌گونه از درک زبان {targetLang} به صحبت کردن آن می‌رسی.",
    d2ModalBtn: "متوجه شدم",
    leaveConfirmTitle: "پیشرفت مرور ذخیره‌نشده",
    leaveConfirmBody: "در این جلسه کارت‌هایی را مرور کرده‌اید که هنوز ذخیره نشده‌اند. اگر اکنون بدون ذخیره خارج شوید، این پیشرفت از دست می‌رود.",
    leaveConfirmSave: "ذخیره و خروج",
    leaveConfirmDiscard: "نادیده گرفتن و خروج",
    leaveConfirmCancel: "لغو",
    faq: {
      whyTwoQ: "چرا دو دسته؟",
      whyTwoA: "مغز شما یادگیری زبان را با دو مهارت جداگانه ذخیره می‌کند: فهمیدن کلمات وقتی می‌شنوید یا می‌خوانید، و تولید آن‌ها وقتی صحبت می‌کنید یا می‌نویسید.\n\nبیشتر اپ‌های فلش‌کارت فقط یک جهت را تمرین می‌دهند. Speafy هر دو را، به ترتیب درست، تمرین می‌دهد.\n\nدسته درک مطلب یک کلمه به زبان {targetLang} به شما نشان می‌دهد و از شما می‌خواهد معنی‌اش را به‌خاطر بیاورید. این مهارت تشخیص را می‌سازد که مغزتان هنگام گوش‌دادن یا خواندن استفاده می‌کند.\n\nدسته تولید یک کلمه به زبان {baseLang} به شما نشان می‌دهد و از شما می‌خواهد آن را به زبان {targetLang} به‌خاطر بیاورید. این مهارت بازیابی را می‌سازد که مغزتان هنگام صحبت‌کردن یا نوشتن استفاده می‌کند. این سخت‌تر است، و همین سختی دقیقاً همان چیزی است که آن را مؤثر می‌کند.",
      whyLaterQ: "چرا قسمت تولید دیرتر شروع می‌شود؟",
      whyLaterA: "تحقیقات علم حافظه نشان می‌دهد که تلاش برای تولید یک کلمه پیش از آنکه واقعاً آن را تشخیص دهید، معمولاً انرژی را هدر می‌دهد و باعث ناامیدی می‌شود. Speafy صبر می‌کند تا مغزتان کلمه را واقعاً از طریق دسته درک مطلب تثبیت کند، سپس آن را به‌طور خودکار وارد دسته تولید می‌کند تا بتوانید دقیقاً در لحظه مناسب تمرین تولید را شروع کنید.",
      whyReturnQ: "چرا کارت‌ها دوباره برمی‌گردند؟",
      whyReturnA: "هر بار که به یک کارت امتیاز می‌دهید، Speafy از یک الگوریتم یادگیری ماشین به نام FSRS، بر پایه سال‌ها تحقیق در علم حافظه، استفاده می‌کند تا مرور بعدی شما را در بهترین زمان ممکن برنامه‌ریزی کند: درست پیش از آنکه به‌طور طبیعی آن را فراموش کنید. هر یادآوری موفق، فاصله زمانی را بیشتر می‌کند. با گذر زمان، کلمات از روز به هفته و ماه بین مرورها فاصله می‌گیرند، تا اینکه برای همیشه بخشی از حافظه بلندمدت شما می‌شوند.",
    },
  },
  grammarLab: {
    title: "📘 آزمایشگاه دستور زبان",
    subtitle: "{count} نکته دستوری برای کاوش",
    backBtn: "← بازگشت",
    searchPlaceholder: "🔍 جستجوی نکات دستوری…",
    noResults: "هیچ نکته دستوری با \"{search}\" مطابقت ندارد",
    allCategories: "همه دسته‌ها",
    allLevels: "همه سطوح",
    notReviewedLabel: "بررسی نشده",
    reviewedLabel: "بررسی شد",
    dueBadge: "{n} در انتظار مرور",
    explanationLabel: "توضیح",
    seeReference: "({term} را ببینید)",
    ruleLabel: "قاعده",
    formsLabel: "صورت‌ها",
    translatingNote: "درحال ترجمه به فارسی...",
    practiceBtn: "▶ تمرین این نکته",
    detailedExplanationBtn: "📖 توضیح کامل",
    practiceTitle: "تمرین",
    practiceQuestion: "این را به ترکی چطور می‌گویی؟",
    practiceOf: "{current} از {total}",
    practiceCorrectFeedback: "درست است!",
    practiceIncorrectFeedback: "دقیق نبود — پاسخ درست {answer} بود.",
    practiceNext: "بعدی →",
    practiceDone: "تمرین تمام شد",
    practiceScore: "{correct} از {total} درست",
    practiceNextReview: "مرور بعدی تا {days} روز دیگر",
    practiceReset: "این بار نه — فردا دوباره این نکته را می‌بینی.",
    practiceAgainBtn: "دوباره تمرین کن",
    practiceCloseBtn: "تمام",
    categories: {
      existential: "وجودی",
      noun_suffix: "پسوند اسمی",
      case_suffix: "پسوند حالت",
      verb_conjugation: "صرف فعل",
      question_particle: "ادات پرسشی",
      copula: "فعل ربطی",
      modal_construction: "ساختار وجهی",
      adjectives: "صفت‌ها",
      case: "حالت",
      modality: "وجهیت",
      mood: "وجه",
      morphology: "صرف‌شناسی",
      morphophonology: "ریخت‌واج‌شناسی",
      phonology: "واج‌شناسی",
      pronouns: "ضمایر",
      register: "سیاق",
      syntax: "نحو",
      tense: "زمان فعل",
      voice: "بنای فعل",
    },
    points: {
      GP0001: { title: "وجود و در دسترس بودن: var / yok", ruleSummary: "[مکان/مالک] + [چیز] + var / yok" },
      GP0002: { title: "پسوند جمع: -ler / -lar", ruleSummary: "اسم + -ler (پیشین) / -lar (پسین)" },
      GP0003: { title: "حالت مکانی: -de / -da / -te / -ta", ruleSummary: "اسم + -de/-da؛ پس از همخوان بی‌واک -te/-ta" },
      GP0004: { title: "حالت به‌ای: -e / -a", ruleSummary: "اسم + -e/-a؛ پس از مصوت، -y- میانجی افزوده می‌شود" },
      GP0005: { title: "حالت ازی: -den / -dan / -ten / -tan", ruleSummary: "اسم + -den/-dan؛ پس از همخوان بی‌واک -ten/-tan" },
      GP0006: { title: "حالت مفعولی معین: -i / -ı / -u / -ü", ruleSummary: "اسم + -i/-ı/-u/-ü؛ -y- میانجی پس از مصوت" },
      GP0007: { title: "زمان حال استمراری — مثبت: -iyor", ruleSummary: "بن فعل + -iyor + شناسه شخصی" },
      GP0008: { title: "زمان حال استمراری — منفی: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "بن فعل + -mıyor/-miyor/-muyor/-müyor + شناسه شخصی" },
      GP0009: { title: "زمان حال استمراری — پرسشی: -iyor mu", ruleSummary: "بن + -iyor + mu(+شناسه)؛ onlar: بن + -iyorlar + mı" },
      GP0010: { title: "ادات پرسشی بله/خیر: mı / mi / mu / mü", ruleSummary: "[واژه] + ادات جدانویس mı/mi/mu/mü ?" },
      GP0011: { title: "گذشته ساده (معین): -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "بن فعل + -di/-dı/-du/-dü (یا -ti/... پس از بی‌واک) + شناسه شخصی" },
      GP0012: { title: "شناسه‌های فعل ربطی (زمان حال): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "مسند + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "پسوندهای ملکی: من / تو / او / ما / شما / آن‌ها", ruleSummary: "(benim/senin/...) اسم + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "بیان خواستن: -mek / -mak istemek", ruleSummary: "[مصدر -mek/-mak] + istemek (صرف‌شده)" },
      GP0015: { title: "درخواست مؤدبانه / امر جمع دوم‌شخص: -in / -iniz", ruleSummary: "بن فعل + -in/-ın/-un/-ün (مؤدبانه) یا -iniz (رسمی‌تر)؛ -y- میانجی پس از مصوت" },
      GP0016: { title: "نرم‌شدن همخوان (بی‌واک‌شدن): p/ç/t/k → b/c/d/ğ", ruleSummary: "[واژه‌ای که به p/ç/t/k ختم می‌شود، اگر از نظر واژگانی نرم‌شونده باشد] + پسوند آغازشده با مصوت ← b/c/d/ğ جای همخوان پایانی را می‌گیرد" },
      GP0017: { title: "بن‌های فعلی بی‌قاعده: gitmek, etmek, yemek, demek", ruleSummary: "git-→gid-, et-→ed-, ye-→yi-, de-→di- پیش از پسوند آغازشده با مصوت" },
      GP0018: { title: "بن‌های حذف‌مصوت پیش از -iyor", ruleSummary: "[بن فعلی که به -e/-a بی‌تکیه ختم می‌شود] + -iyor ← مصوت پایانی حذف می‌شود، سپس -iyor افزوده می‌شود" },
      GP0019: { title: "مصوت‌های ترکی", ruleSummary: "۸ مصوت: a, e, ı, i, o, ö, u, ü — هر یک پیشین/پسین و غیرگرد/گرد است" },
      GP0020: { title: "هماهنگی مصوت‌ها", ruleSummary: "مصوت پسوند با آخرین مصوت واژه هماهنگ می‌شود: بن پیشین ← مصوت پسوند پیشین، بن پسین ← مصوت پسوند پسین (و برای پسوندهای چهارگانه، گرد/غیرگرد نیز هماهنگ می‌شود)" },
      GP0021: { title: "حالت ملکی (اضافه): -in/-ın/-un/-ün", ruleSummary: "[اسم] + in/ın/un/ün (هماهنگی چهارگانه؛ اگر اسم به مصوت ختم شود، -n- میانجی افزوده می‌شود)" },
      GP0022: { title: "صفات ملکی (benim, senin, onun...)", ruleSummary: "ضمیر شخصی + پسوند ملکی: ben→benim, sen→senin, o→onun, biz→bizim, siz→sizin, onlar→onların" },
      GP0023: { title: "زمان آینده: -ecek/-acak", ruleSummary: "[بن] + (y) + ecek/acak (پیش از شناسه شخصیِ آغازشده با مصوت، k→ğ) + شخص" },
      GP0024: { title: "گذشته نقلی (شنیداری): -miş", ruleSummary: "[بن] + mış/miş/muş/müş (هماهنگی چهارگانه) + شناسه شخصیِ مسندی" },
      GP0025: { title: "گذشته استمراری: -iyordu", ruleSummary: "[بن به شکل -iyor] + du/dun/duk/dunuz (پیش از -dı برای سوم‌شخص جمع، -lar افزوده می‌شود)" },
      GP0026: { title: "توانایی: -ebilmek/-abilmek («توانستن») - مثبت", ruleSummary: "[بن] + (y)e/(y)a + bil + ir (همیشه -ir، به‌دلیل استثنای ثابتِ زمان حال ساده‌ی خودِ bilmek) + شخص" },
      GP0027: { title: "ترتیب واژگان", ruleSummary: "پیش‌فرض: نهاد - مفعول/مکان - فعل (فعل در پایان). برای تأکید انعطاف‌پذیر است؛ نقش با پسوندهای حالت مشخص می‌شود، نه با جایگاه." },
      GP0028: { title: "حروف ربط", ruleSummary: "ve (و)، ama (اما)، çünkü (زیرا)، veya (یا) - واژه‌های ثابت، بدون صرف پسوندی" },
      GP0029: { title: "حروف اضافه پسین", ruleSummary: "ile (با)، için (برای)، gibi (مانند)، kadar (تا/به‌اندازه)، önce (پیش از)، sonra (پس از) - همگی پس از اسم می‌آیند" },
      GP0030: { title: "صفت تفضیلی و عالی", ruleSummary: "daha + صفت (تفضیلی)؛ en + صفت (عالی)؛ [اسم-حالت ازی] daha [صفت] = «صفت‌تر از اسم»" },
      GP0031: { title: "قیدهای ترکی (بسامد/درجه)", ruleSummary: "çok (خیلی/بسیار)، az (کمی)، hiç (هرگز/اصلاً - با فعل منفی)، bazen (گاهی)، şimdi (اکنون)" },
      GP0032: { title: "زمان حال ساده (عادتی): -er/-ir/-ar/-ır", ruleSummary: "چندهجایی: [بن]+ir/ır/ur/ür (پایان‌یافته به همخوان، قاعده‌مند) یا [بن]+r (پایان‌یافته به مصوت، قاعده‌مند). تک‌هجایی پایان‌یافته به همخوان: از نظر واژگانی بین -Ar و -Ir دوپاره است - برای هر فعل جداگانه بررسی شود، حدس زده نشود." },
      GP0033: { title: "گذشته عادتی: -erdi/-ırdı («عادت داشتن به»)", ruleSummary: "[بن زمان حال ساده] + di/dı/du/dü (چهارگانه، بر پایه مصوت خودِ -ir/-ar) + شخص" },
      GP0034: { title: "آینده در گذشته: -ecekti/-acaktı («قرار بود»)", ruleSummary: "[بن آینده] + ti (بی‌واک، مفرد/جمع اول‌شخص) یا + ler + di (واک‌دار، سوم‌شخص جمع، چون -ler به 'r' ختم می‌شود بی‌واکی رخ نمی‌دهد)" },
      GP0035: { title: "شرطی غیرواقعی: -se/-sa (بن ساده)", ruleSummary: "[بن] + se/sa (دوگانه) + شخص (m, n, -, k, niz, ler)" },
      GP0036: { title: "لزوم: -malı/-meli («باید»)", ruleSummary: "[بن] + malı/meli (دوگانه) + (y) + شناسه شخصیِ مسندی" },
      GP0037: { title: "صفت فاعلی: -en/-an («کسی که...»)", ruleSummary: "[بن] + en/an (دوگانه)؛ بن‌های پایان‌یافته به مصوت، -y- میانجی می‌گیرند" },
      GP0038: { title: "بند زمانی: -ince/-ınca («وقتی که...»)", ruleSummary: "[بن پایان‌یافته به همخوان] + ince/ınca (دوگانه، الگوی تأییدشده)؛ الگو برای بن‌های پایان‌یافته به مصوت هنوز تأیید نشده است" },
      GP0039: { title: "مقایسه زمان‌های گذشته", ruleSummary: "-di (شاهدی) در برابر -miş (نقلی) در برابر -iyordu (در حال انجام بود) در برابر -irdi (عادت داشت)" },
      GP0040: { title: "صورت‌های حالتیِ ضمایر اشاره: bu/şu/o", ruleSummary: "bu/şu/o + n (میانجی) + پسوند حالت" },
      GP0041: { title: "قیدهای اشاره مکانی: bura/şura/ora («اینجا/آنجا»)", ruleSummary: "bura/şura/ora + پسوند حالت (-y- میانجی فقط پیش از حالت به‌ای)" },
      GP0042: { title: "واژه‌های پرسشی", ruleSummary: "ne, kim, nerede, nasıl, kaç, ne zaman, neden - همگی ثابت" },
      GP0043: { title: "حالت ابزاری: -(y)le/-(y)la («با / به‌وسیله»)", ruleSummary: "[اسم] + (y)le/(y)la (هماهنگی دوگانه؛ اگر به مصوت ختم شود -y- میانجی می‌گیرد)" },
      GP0044: { title: "پسوندهای صفت‌ساز «دار/بدون»: -lı/-siz", ruleSummary: "[اسم] + lı/li/lu/lü («دارای») یا sız/siz/suz/süz («بدون») - هماهنگی چهارگانه" },
      GP0045: { title: "ناتوانی: -(y)AmA- («نتوانستن»)", ruleSummary: "[بن] + (y)e/(y)a + me/ma + شناسه شخصیِ زمان حال ساده‌ی منفی (m/mez-sin/mez/meyiz/mez-siniz/mez-ler)" },
      GP0046: { title: "شرطی واقعی: [بن زمان حال ساده] + -se/-sa («اگر X رخ دهد»)", ruleSummary: "[بن زمان حال ساده] + se/sa (دوگانه، بر پایه مصوت خودِ پسوند زمان حال ساده) + شخص" },
      GP0047: { title: "صفت مفعولی: -DIk + پسوند ملکی («که [نهاد] فلان کرد»)", ruleSummary: "[بن] + DIk (چهارگانه؛ فقط پیش از پسوند ملکیِ آغازشده با مصوت به ğ نرم می‌شود) + پسوند ملکی" },
      GP0048: { title: "کاربرد صفت فعلی آینده (از صورت‌های زمان آینده دوباره استفاده می‌کند)", ruleSummary: "همان صورت‌های ظاهریِ زمان آینده (see GP0023)، اما به‌جای فعل صرف‌شده، به‌صورت صفت پیش از اسم به کار می‌رود" },
      GP0049: { title: "بندهای زمانی: -DIğI zaman / -mADIğI zaman / -DIktan sonra", ruleSummary: "[صفت مفعولی] + zaman = «وقتی که»؛ [صورت ساده -DIk] + ten + sonra = «پس از»" },
      GP0050: { title: "پسوند -ki (نسبت‌ساز)", ruleSummary: "[اسم در حالت مکانی / ضمیر در حالت ملکی] + ki (ثابت - بدون هماهنگی)" },
      GP0051: { title: "تداوم زمانی: -DAn beri / -DIr («از ... تاکنون / مدتی است که»)", ruleSummary: "[زمان]+den beri = «از X تاکنون»؛ [مدت]+dir/dır/dur/dür + زمان حال = «مدتی است که X (و همچنان ادامه دارد)»" },
      GP0052: { title: "بنای مجهول: -Il/-In", ruleSummary: "پایان‌یافته به همخوان (به‌جز l): +Il/ıl/ul/ül؛ پایان‌یافته به l: +In/ın/un/ün؛ پایان‌یافته به مصوت: +n" },
      GP0053: { title: "بنای سببی: -t/-DIr/-Ir (فقط فهرست گزیده - از نظر واژگانی پیچیده)", ruleSummary: "صورت واژگانی هر فعل جداگانه تعیین می‌شود - هر فعل را جداگانه بررسی کنید، تعمیم ندهید" },
      GP0054: { title: "بنای انعکاسی (خودی): -In/-ın («انجام کاری بر خود»)", ruleSummary: "[بن] + In/ın/un/ün (یا پس از مصوت فقط n) - معنای انعکاسی، مانند بنای مجهول (see GP0052) از نظر واژگانی تعیین می‌شود" },
      GP0055: { title: "بنای مشارکتی (متقابل): -Iş/-ış («انجام کاری با/به یکدیگر»)", ruleSummary: "[بن] + Iş/ış/uş/üş (چهارگانه) - کنش متقابل/مشترک" },
      GP0056: { title: "وجه التزامی خواستاری (بگذار من/بیا): -(y)eyim/-(y)elim", ruleSummary: "[بن] + (y)eyim (اول‌شخص مفرد) / (y)elim (اول‌شخص جمع) - هماهنگی دوگانه" },
      GP0057: { title: "سیاق روایی: تکرار -mış (داستان‌گویی)", ruleSummary: "-mış برای حفظ سیاق روایی، نه فقط یک‌بار بلکه به‌طور مکرر در سراسر یک روایت به کار می‌رود" },
      GP0058: { title: "«Ne kadar da» (تشدیدکننده - «چقدر...!»)", ruleSummary: "Ne kadar da + [صفت] = تشدیدکننده تعجبی" },
      GP0059: { title: "قید فعلی حالتی: -ArAk («با انجام دادن X / درحالی‌که X می‌کند»)", ruleSummary: "[بن] + arak/erek (هماهنگی دوگانه)" },
      GP0060: { title: "قید فعلی توالی: -Ip («و، پس از انجام X»)", ruleSummary: "[بن] + Ip/ıp/up/üp (چهارگانه) - فقط آخرین فعل زنجیره صرف زمانی می‌گیرد" },
      GP0061: { title: "بند علّی: -DIğI için («چون X [رخ داد]»)", ruleSummary: "[صفت مفعولی] (see GP0047) + için (see GP0029) = «چون X»" },
      GP0062: { title: "«Diye» («با این فکر/گفتار که...»)", ruleSummary: "[بند] + diye + [بند اصلی] = «با این فکر/به این دلیل که [بند]، [بند اصلی]»" },
      GP0063: { title: "«Olarak» («به‌عنوان X»)", ruleSummary: "[اسم] + olarak = «به‌عنوان [اسم]»" },
      GP0064: { title: "«Tarafından» (نشانگر عامل مجهول - «توسط X»)", ruleSummary: "[گروه اسمی] + tarafından + [فعل مجهول] (see GP0052)" },
      GP0065: { title: "«Rağmen» («با وجود / علی‌رغم»)", ruleSummary: "[اسم + حالت به‌ای] (see GP0004) + rağmen = «علی‌رغم X»" },
      GP0066: { title: "«Göre» («طبق / بنابر»)", ruleSummary: "[اسم/ضمیر + حالت به‌ای] + göre = «طبق X»" },
      GP0067: { title: "افعال شبه‌وجهی + متمم حالت به‌ای", ruleSummary: "[اسم/فعل-mA] + حالت به‌ای + alışmak/başlamak/çalışmak/karar vermek/izin vermek/benzemek/inanmak/üzülmek" },
      GP0068: { title: "بیان‌های معرفت‌شناختی و شنیداری", ruleSummary: "gibi geliyor = «به‌نظر می‌رسد» (see GP0029) (see GP0007)؛ -mış olmalı = «باید ... کرده باشد» (see GP0024) (see GP0036)؛ -mış görünmek = «به‌نظر می‌رسد ... کرده است»؛ bildiğim kadarıyla = «تا آنجا که می‌دانم» (see GP0047) (see GP0029) (see GP0043)" },
      GP0069: { title: "افعال پرکاربرد + مفعول در حالت مفعولی: unutmak, sormak, hatırlamak", ruleSummary: "[اسم + حالت مفعولی] (see GP0006) + unutmak/sormak/hatırlamak" },
      GP0070: { title: "Konuşmak در برابر Söylemek («صحبت کردن» در برابر «گفتن»)", ruleSummary: "konuşmak = عمل صحبت‌کردن (زبان/شخص)؛ söylemek = گفتنِ [چیزی مشخص]، با مفعول در حالت مفعولی" },
    },
  },
  placementTest: {
    title: "🎯 آزمون تعیین سطح",
    offerTitle: "از قبل کمی ترکی بلدید؟",
    offerBody: "یک آزمون تعیین سطح کوتاه — حدود ۲۰ سؤال — بدهید تا نقطهٔ شروعتان مشخص شود. درس فعلی شما بر همین اساس تنظیم می‌شود، اما همهٔ موضوعات همچنان برای مرور باز می‌مانند.",
    startBtn: "شروع آزمون",
    notNowBtn: "الان نه",
    roundLabel: "دور {round} از {totalRounds}",
    questionLabel: "سؤال {n} از {total}",
    notSureOption: "مطمئن نیستم",
    notSureHint: "(اگر ۱۰۰٪ مطمئن نیستید، گزینهٔ پنجم را انتخاب کنید.)",
    wordPrompt: "این کلمه به چه معناست؟",
    listeningPrompt: "گوش کنید و کلمه‌ای را که شنیدید انتخاب کنید",
    listeningReplay: "پخش دوباره",
    preparingRound: "در حال آماده‌سازی سؤالات…",
    finishBtn: "دیدن نتیجه‌ام",
    resultsTitle: "نتیجهٔ تعیین سطح شما",
    resultsLevel: "شما در سطح {level} قرار گرفتید",
    resultsBody: "درس فعلی شما اکنون از این سطح شروع می‌شود. همچنان می‌توانید هر موضوع قبلی یا بعدی را در همهٔ درس‌ها مرور کنید.",
    continueBtn: "ادامه",
  },
  goals: {
    title: "🎯 اهداف من",
    displayName: "نام نمایشی",
    namePlaceholder: "اسمت…",
    vocabTarget: "هدف تعداد واژه",
    words: "کلمه",
    minWords: "حداقل ۱٬۵۰۰",
    midWords: "۲٬۰۰۰",
    maxWords: "حداکثر ۳٬۵۰۰",
    courseDuration: "مدت دوره هدف",
    months: "ماه",
    month: "ماه",
    monthsPlural: "ماه",
    daysSummary: "= {days} روز",
    baseLanguage: "زبان پایه",
    otherLanguage: "زبان‌های دیگر (به‌زودی)",
    selectLanguage: "یک زبان انتخاب کنید…",
    ok: "تأیید",
    langNames: {
      English: "انگلیسی", Farsi: "فارسی", Arabic: "عربی",
      French: "فرانسوی", German: "آلمانی", Spanish: "اسپانیایی",
      Russian: "روسی", Portuguese: "پرتغالی", Chinese: "چینی",
      Turkish: "ترکی", Hindi: "هندی", Italian: "ایتالیایی",
    },
    targetLanguage: "زبان هدف",
    targetLangNames: {
      Turkish: "ترکی",
    },
    wordsLbl: "کلمه",
    wordsPerDay: "کلمه/روز",
    daysLbl: "روز",
    saved: "✅ اهداف ذخیره شد!",
  },
  progress: {
    title: "📈 پیشرفت من",
    memDistTitle: "توزیع حالت حافظه · {n} کارت",
    inAcquisition: "در حال فراگیری",
    rooted: "ریشه دوانده",
    fluent: "روان",
    deeplyRetained: "عمیقاً تثبیت شده",
    acqDesc: "پایداری کمتر از ۳ روز",
    rootedDesc: "پایداری ۳ تا ۲۱ روز",
    fluentDesc: "پایداری ۲۱ تا ۹۰ روز",
    retainedDesc: "پایداری بیش از ۹۰ روز",
    forecastTitle: "پیش‌بینی مرور — ۱۵ روز آینده",
    cardsDue: "کارت‌های سررسید",
    today: "امروز",
    tmrw: "فردا",
    plusDays: "+{n}ر",
    todayFull: "امروز",
    tmrwFull: "فردا",
    plusDaysFull: "+{n} روز",
    goalProgress: "پیشرفت کلی هدف",
    wordsLearned: "{learned} / {target} کلمه یاد گرفته شد",
    vocabGrowth: "رشد واژگان",
    noChart: "اولین درست رو کامل کن تا نمودارت رو ببینی! 📚",
    wordsLearnedSeries: "کلمات یاد گرفته",
    topicRings: "حلقه‌های حافظه موضوع",
    quickStats: "آمار سریع",
    dayStreak: "روز متوالی 🔥",
    lessonsDone: "درس انجام‌شده",
    totalStudy: "کل مطالعه",
    avg14Day: "میانگین ۱۴ روز",
    minUnit: "دقیقه",
    dayLabel: "روز {n}",
    cards: "کارت",
  },
  myVocab: {
    title: "📝 واژگان من",
    summaryTitle: "{n} کلمه آموخته‌شده",
    searchPlaceholder: "🔍 جستجوی کلمات شما…",
    allStatuses: "همه وضعیت‌ها",
    noResults: "کلمه‌ای با \"{search}\" مطابقت ندارد",
    noWords: "برای شروع ساختن واژگان خود یک درس را کامل کن! 📚",
    completedTopicsTitle: "موضوعات تکمیل‌شده ({n} از {total})",
    noDate: "—",
  },
  trial: {
    daysLeftBadge: "⏱ {n} روز باقی‌مانده",
    expiredBadge: "آزمایشی تمام شد · ارتقا ↑",
    pausedBadge: "⏸ متوقف شده",
    proBadge: "✦ پلن حرفه‌ای",
    eliteBadge: "✦ پلن Elite",
  },
  paywall: {
    back: "← بازگشت",
    title: "ارتقا به Speafy Pro",
    subTrialExpired: "دوره آزمایشی شما به پایان رسید. برای ادامه یادگیری ارتقا دهید.",
    subDefault: "همه درس‌ها و مرور فلش‌کارت را باز کنید.",
    features: [
      "همه {count} درس به‌طور کامل باز شده",
      "چت نامحدود با بابی، مربی هوش مصنوعی",
      "مرور هوشمند فلش‌کارت FSRS",
      "ردیابی پیشرفت و تحلیل حافظه",
      "صدای اصیل برای هر کلمه",
      "مکالمات تمرینی",
      "رابط کاربری چندزبانه",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "تمام امکانات Speafy Pro",
      "آزمایشگاه گوش کن و صحبت کن — تمرین مکالمه با بابی",
      "۳ ساعت مکالمه صوتی با بابی در هر ماه",
      "امکان خرید دقایق صوتی اضافه — ۳ دلار در ساعت",
    ],
    billingMonthly: "ماهانه",
    billingYearly: "سالانه",
    saveBadge: "۲۵٪ تخفیف",
    pricePerMonth: "/ماه",
    priceBilledYearly: "پرداخت سالانه",
    cta: "شروع Speafy Pro →",
    ctaElite: "شروع Speafy Elite →",
    fine: "قابل لغو در هر زمان | پرداخت امن از طریق Paddle",
    bannerExpired: "دوره آزمایشی رایگان شما به پایان رسید.",
    bannerActive: "آزمایشی رایگان — {n} روز باقی‌مانده.",
    bannerBtn: "ارتقا ↑",
    settingsFreePlan: "پلن رایگان",
    pausedTitle: "اشتراک شما متوقف شده است",
    pausedSub: "برای باز کردن دوباره درس‌های جدید، اشتراک خود را از بخش تنظیمات از سر بگیرید.",
    pausedGoToSettingsBtn: "برو به تنظیمات",
    alreadyProTitle: "شما از قبل Pro هستید!",
    alreadyProSub: "اشتراک شما فعال است — نیازی به خرید دوباره نیست.",
    alreadyProGoHomeBtn: "برو به خانه",
    settingsTrialRemaining: "آزمایشی — {n} روز باقی‌مانده",
    settingsTrialEnded: "آزمایشی تمام شد — برای باز کردن همه درس‌ها ارتقا دهید",
    settingsFreeForever: "از همان جا که رها کردی ادامه بده — برای باز کردن همه درس‌ها ارتقا بده",
    settingsUpgradeBtn: "ارتقا",
  },
  badges: {
    newbie: "تازه‌کار",
    wordExplorer: "کاوشگر کلمات",
    wordNerd: "دیوانه کلمات",
    wordWizard: "جادوگر کلمات",
    rockstar: "ستاره راک",
    expert: "خبره",
    champion: "قهرمان",
  },
  memStates: {
    inAcquisition: "در حال فراگیری",
    rooted: "ریشه دوانده",
    fluent: "روان",
    deeplyRetained: "عمیقاً تثبیت شده",
  },
  chat: {
    subtitle: "معلم ترکی شما",
    greetWords: ["سلام", "درود", "عزیز"],
    // "عزیز" is a postpositive adjective in Persian ("Hooman عزیز", not "عزیز Hooman"),
    // unlike "سلام"/"درود" which precede the name — so it needs name+word reversed.
    greetWordsAfterName: ["عزیز"],
    greeting: "{greetedName}،\n\nهر سوالی درباره زبان ترکی (دستور، واژگان، فرهنگ) یا نحوه استفاده از این اپ داری بپرس.",
    placeholder: "درباره ترکی یا اپ بپرس…",
    error: "متأسفانه، الان نمی‌تونم وصل بشم. لطفاً دوباره امتحان کنید.",
    escalationFallback: "متأسفم که نتونستم به‌طور کامل در این مورد کمکتون کنم. این موضوع رو به تیممون اطلاع دادم و پاسخ رو از طریق ایمیل دریافت خواهید کرد — معمولاً ظرف ۲ روز کاری. همچنین می‌تونید مستقیماً از طریق support@speafy.com با ما در تماس باشید.",
    welcome: "سلام، {name}! 👋 به Speafy خوش اومدی! من بابی‌ام و برای دو کار اینجام: کمک به آشنایی‌ تو با اپ و رفع مشکلات فنی یا پاسخ به پرسشهای تو درباره نحوه استفاده از اپ، و همچنین پاسخ به هر سؤالی که درباره زبان ترکی داری.\n\nبا درس فعلی شروع کن، یا یک موضوع از «همه درس‌ها» انتخاب کن. فراموش نکن که هر درس را وقتی تمام شد به عنوان «کامل شده» علامت بزنی، و بعد فلش‌کارت‌ها را مرور کنی.\n\nهر وقت خواستی ازم بپرس — درباره اپ یا درباره {targetLanguage}.\n\nموفق باشی در سفر یادگیریت! 😊",
    lessonLimit: "امروز {limit} درس رو کامل کردی — عالیه! 🌟\n\nبرای اینکه یادگیریت پایدار بمونه و صف فلش‌کارت‌هات زیادی شلوغ نشه، روزانه حداکثر {limit} درس تعیین شده.\n\nکمی به مغزت استراحت بده تا مطالب امروز رو تثبیت کنه. چطوره به‌جاش یه جلسه مرور فلش‌کارت داشته باشی؟ خیلی کمک می‌کنه به تقویت یادگیریت.\n\nفردا اینجام که با درس‌های بیشتر پیشت باشم! 😊",
    streakDecayed: "خوش برگشتی! 👋 {days} روز نبودی. به‌لطف {protection} روز محافظ استریک 🛡️ که کسب کرده بودی، استریکت فقط از {oldStreak} به {newStreak} کم شد، نه اینکه کامل از بین بره. بیا به ساختنش ادامه بدیم!",
    streakWiped: "خوش برگشتی! 👋 {days} روز نبودی — بیشتر از {protection} روز محافظ استریک 🛡️ که ذخیره کرده بودی، برای همین استریکت از ۱ شروع شد. هر استریکی یه جایی شروع می‌شه — بیا دوباره بسازیمش!",
    weeklyRecapFallback: "سلام! 👋 می‌خواستم خلاصه هفتگی‌ت رو بیارم، ولی الان تو آماده کردنش مشکل دارم. ولی سریع بگم — استریک {streak} روزه‌ت ادامه داره، همینطوری پیش برو! 🔥",
    dailyPlanQuestion1: "سلام! 👋 امروز چقدر وقت برای درس خوندن داری؟",
    dailyPlanQuestion2: "سلام! 😊 یه برنامه مطالعه برات دارم — امروز چند دقیقه وقت داری؟",
    dailyPlanQuestion3: "آماده‌ی برنامه‌ی امروز هستی؟ 🎯 فقط تقریبی بگو چقدر وقت داری.",
    dailyPlanClarify: "ببخشید، درست متوجه نشدم! می‌تونی یه عدد تقریبی بگی، مثل '۲۰' یا '۳۰ دقیقه'؟",
    dailyPlanUnreasonable: "این خیلی شبیه یه جلسه مطالعه‌ی معمولی نیست! می‌تونی یه عددی بین ۵ دقیقه تا حدود ۵ ساعت بهم بگی؟",
    dailyPlanGiveUp: "مشکلی نیست — هر وقت آماده بودی، فقط برو سراغ فلش‌کارت‌ها یا درس فعلیت و شروع کن! 😊",
    dailyPlanFallback: "وقتت رو یادداشت کردم، ولی الان تو ساختن برنامه‌ی امروز مشکل دارم. در همین حین، اگه کارت‌های سررسیده داری، فلش‌کارت‌ها همیشه گزینه‌ی خوبیه! 😊",
    sendBtn: "ارسال",
    askBabi: "از بابی بپرس",
    voiceConsentTitle: "گفت‌وگوی صوتی با بابی روشن شود؟",
    voiceConsentBody: "بابی از میکروفون شما برای شنیدن صدایتان و از بلندگو برای پاسخ دادن استفاده می‌کند. گفتار شما به متن تبدیل می‌شود — خود ضبط صوتی هرگز نگه‌داری نمی‌شود. متن ممکن است تا ۳۰ روز نگه‌داری شود. برای جزئیات بیشتر به سیاست حریم خصوصی ما مراجعه کنید.",
    voiceConsentPrivacyLink: "سیاست حریم خصوصی",
    voiceConsentAllow: "اجازه دسترسی به میکروفون",
    voiceConsentDecline: "الان نه",
    voiceDenied: "بدون دسترسی به میکروفون، گفت‌وگوی صوتی در دسترس نیست. می‌توانید با تایپ کردن به گفت‌وگو ادامه دهید — هر زمان خواستید روی نماد میکروفون ضربه بزنید تا دوباره امتحان کنید.",
    voiceDeviceInUse: "به‌نظر می‌رسد میکروفون شما در جای دیگری در حال استفاده است — برنامه‌های دیگری که از آن استفاده می‌کنند را ببندید و دوباره امتحان کنید.",
    voiceError: "مشکلی در گفت‌وگوی صوتی پیش آمد. لطفاً دوباره امتحان کنید.",
    voiceStarting: "در حال شروع… لطفاً صبر کنید",
    voiceListening: "در حال گوش دادن…",
    voiceProcessing: "در حال فهمیدن…",
    voiceReviewHint: "برای ویرایش ضربه بزنید، وگرنه این پیام تا چند ثانیه دیگر خودکار ارسال می‌شود.",
    voiceSendNow: "اکنون ارسال کن",
    voiceDiscard: "نادیده بگیر",
    voiceEditTranscript: "ویرایش آنچه بابی شنید",
    voiceBadgeLabel: "با صدا ارسال شد",
    voiceDidntCatch: "متوجه نشدم — برای امتحان دوباره روی میکروفون ضربه بزنید.",
    voiceSpeaking: "بابی در حال صحبت است…",
    voiceTtsUnavailable: "صدا برای این پاسخ در دسترس نبود — به‌جای آن متن نمایش داده می‌شود.",
    voiceTtsUnavailableLanguage: "پاسخ صوتی بابی هنوز به {language} در دسترس نیست.",
    voiceTapToHear: "برای شنیدن پاسخ بابی ضربه بزنید",
    voiceNotEntitled: "گفت‌وگوی صوتی با بابی یک قابلیت ویژه است — برای استفاده از آن ارتقا دهید.",
    voiceNoBalance: "شما تمام دقایق صوتی این دوره را استفاده کرده‌اید. در دوره بعدی دوباره شارژ می‌شوند.",
    voiceOtherTabActive: "گفت‌وگوی صوتی از قبل در تب دیگری فعال است.",
    voiceLowBalanceNudge: "دقایق صوتی این دوره رو به اتمام است.",
    voiceLowMinutesHeadsUp: "دقایق صوتی این دوره‌تان رو به اتمام است.",
    voiceGetMoreMinutes: "دریافت دقیقه بیشتر",
    voiceStopBtn: "توقف",
    voiceMicButtonLabel: "گفت‌وگوی صوتی",
    voiceBannerDismiss: "بستن",
  },
  settings: {
    title: "تنظیمات",
    accountSection: "حساب کاربری",
    linkedGoogle: "متصل به Google",
    emailAccountBadge: "حساب ایمیلی",
    changeNameBtn: "تغییر نام کاربری",
    nameSaveBtn: "ذخیره",
    nameCancelBtn: "لغو",
    nameSaving: "در حال ذخیره…",
    passwordLabel: "رمز عبور",
    passwordSub: "ارسال لینک بازنشانی به ایمیل شما",
    passwordSent: "ارسال شد ✓",
    passwordResetBtn: "بازنشانی",
    subscriptionSection: "اشتراک",
    subscriptionAdminLabel: "حساب مدیریت",
    subscriptionAdminSub: "شما به همه‌ی امکانات دسترسی کامل و همیشگی دارید.",
    subscriptionReviewerLabel: "دسترسی بازبین",
    subscriptionReviewerSub: "شما به عنوان بازبین برنامه، به‌صورت رایگان به همه‌ی امکانات دسترسی دارید.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "سالانه",
    subscriptionPlanMonthly: "ماهانه",
    subscriptionRenews: "تمدید در {date}",
    subscriptionActive: "فعال",
    subscriptionManageLink: "صورتحساب و فاکتورها",
    subscriptionCancelLink: "لغو یا توقف موقت اشتراک",
    subscriptionPaymentFailedLabel: "آخرین پرداخت شما ناموفق بود",
    subscriptionPaymentFailedSub: "پرداخت در تاریخ {date} ناموفق بود",
    subscriptionPaymentFailedSubNoDate: "لطفاً برای حفظ دسترسی پرو، روش پرداخت خود را به‌روزرسانی کنید",
    subscriptionUpdatePaymentLink: "به‌روزرسانی روش پرداخت ↗",
    subscriptionCancelledPending: "اشتراک شما در تاریخ {date} پایان می‌یابد — تا آن زمان دسترسی پرو را حفظ خواهید کرد",
    subscriptionPausedLabel: "اشتراک متوقف شده",
    subscriptionPausedSub: "در تاریخ {date} به‌طور خودکار از سر گرفته می‌شود — مگر اینکه زودتر آن را از سر بگیرید، هزینه کامل یک دوره جدید دریافت خواهد شد",
    subscriptionPausedSubNoDate: "پس از ۳ ماه به‌طور خودکار از سر گرفته می‌شود، مگر اینکه زودتر آن را از سر بگیرید",
    subscriptionResumeBtn: "اکنون از سر بگیر",
    subscriptionResuming: "در حال از سر گیری…",
    pausePendingLabel: "توقف زمان‌بندی شده",
    pausePendingSub: "در پایان دوره صورتحساب فعلی شما، در تاریخ {date} اعمال می‌شود",
    manageOfferTitle: "به فکر لغو اشتراک هستید؟",
    manageOfferSub: "در عوض متوقف کنید — پیشرفت خود را تا {date} حفظ می‌کنید، سپس پس از ۳ ماه به‌طور خودکار از سر گرفته می‌شود و هزینه کامل یک دوره جدید دریافت خواهد شد، مگر اینکه زودتر از سر بگیرید.",
    manageOfferPauseBtn: "در عوض متوقف کن",
    manageOfferContinueLink: "همچنان لغو کن",
    manageOfferDismiss: "بی‌خیال",
    pauseOfferLabel: "به یک وقفه نیاز دارید؟",
    pauseOfferSub: "به‌جای لغو، اشتراک خود را برای ۳ ماه متوقف کنید — پیشرفت خود را حفظ کنید و هر زمان که خواستید از سر بگیرید.",
    pauseOfferBtn: "توقف اشتراک",
    pauseConfirmP1: "اشتراک Speafy Pro شما متوقف شود؟",
    pauseConfirmC1: "دوره صورتحساب فعلی شما تا {date} ادامه می‌یابد — هر چیزی که قبلاً پرداخته‌اید حفظ می‌شود.",
    pauseConfirmC2: "در طول توقف، درس‌های جدید قفل می‌شوند (مانند یک پلن رایگان منقضی‌شده)، اما همچنان می‌توانید کارت‌های موجود خود را به‌طور عادی مرور کنید.",
    pauseConfirmC3: "این توقف دقیقاً ۳ ماه طول می‌کشد. اگر پیش از آن به‌صورت دستی از سر نگیرید، اشتراک شما به‌طور خودکار از سر گرفته شده و هزینه کامل یک دوره جدید دریافت می‌شود.",
    pauseConfirmBtn: "تأیید توقف",
    pausing: "در حال توقف…",
    pauseFailedGeneric: "مشکلی در توقف اشتراک شما پیش آمد. لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.",
    manageLinkLoading: "در حال بارگذاری…",
    manageLinkFailedGeneric: "در حال حاضر امکان بارگذاری لینک مدیریت وجود ندارد. لطفاً دوباره تلاش کنید.",
    resumeConfirmP1: "اشتراک Speafy Pro شما اکنون از سر گرفته شود؟",
    resumeConfirmC1: "بلافاصله هزینه کامل یک دوره صورتحساب جدید از شما دریافت خواهد شد.",
    resumeConfirmBtn: "بله، اکنون از سر بگیر",
    resumeFailedGeneric: "مشکلی در از سر گیری اشتراک شما پیش آمد. لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.",
    subscriptionLastCharge: "آخرین پرداخت: {amount} در {date} — {status}",
    subscriptionLastChargePaid: "پرداخت‌شده",
    subscriptionLastChargeFailed: "ناموفق",
    tierChangePendingLabel: "تغییر پلن زمان‌بندی شد",
    tierChangePendingToElite: "تغییر به Elite در {date}",
    tierChangePendingToBasic: "تغییر به Pro در {date}، در پایان دوره صورت‌حساب فعلی شما",
    tierUpgradeToEliteLink: "ارتقا به Elite",
    tierDowngradeToBasicLink: "بازگشت به Pro",
    tierUpgradeConfirmTitle: "ارتقا به Elite؟",
    tierUpgradeConfirmSub: "امروز تفاوت نسبی از شما دریافت می‌شود و بلافاصله ۳ ساعت مکالمه صوتی Elite با بابی را دریافت می‌کنید — از این پس {price}/{interval}.",
    tierDowngradeConfirmTitle: "بازگشت به Pro؟",
    tierDowngradeConfirmSub: "تا {date} از Elite بهره‌مند خواهید بود، سپس در تاریخ صورت‌حساب بعدی به Pro تغییر می‌کنید — امروز هزینه‌ای دریافت نمی‌شود.",
    tierUpgradeConfirmBtn: "بله، همین حالا ارتقا بده",
    tierDowngradeConfirmBtn: "بله، به Pro برگرد",
    tierChangeBusy: "در حال به‌روزرسانی…",
    tierChangeFailedGeneric: "مشکلی در تغییر پلن شما پیش آمد. لطفاً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.",
    voiceMinutesLabel: "زمان گفتگوی صوتی ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "آزمایشی",
    voiceTierAdmin: "مدیر",
    voiceTierViewer: "بازدیدکننده",
    voiceMinutesUsed: "{used} از {limit} در این دوره استفاده شده",
    voiceMinutesPurchasedExtra: "به‌علاوه {extra} خریداری‌شده — پس از تمام‌شدن دقیقه‌های ماهانه مصرف می‌شود و هرگز منقضی نمی‌شود",
    yourDataSection: "داده‌های شما",
    marketingLabel: "رضایت برای ارتباطات بازاریابی",
    marketingSub: "به‌روزرسانی‌ها، اعلان‌ها و پیشنهادهای ویژه",
    voiceConsentLabel: "گفت‌وگوی صوتی با بابی",
    voiceConsentSub: "به بابی اجازه دهید صدای شما را بشنود و بلند پاسخ دهد",
    privacyLegalSection: "حریم خصوصی، شرایط و مسائل حقوقی",
    privacyPolicyLabel: "سیاست حریم خصوصی",
    privacyPolicySub: "چگونگی جمع‌آوری، استفاده و محافظت از داده‌های شما",
    viewLink: "مشاهده",
    termsLabel: "شرایط خدمات",
    termsSub: "قوانین و شرایط حاکم بر استفاده شما",
    refundLabel: "سیاست بازپرداخت",
    refundSub: "شرایط واجد شرایط بودن و نحوه درخواست بازپرداخت",
    cookieSettingsLabel: "تنظیمات کوکی",
    cookieSettingsSub: "مدیریت کوکی‌های تحلیلی و عملکردی",
    manageLink: "مدیریت",
    privacySection: "حریم خصوصی و داده‌ها",
    exportLabel: "خروجی گرفتن از داده‌هایم",
    exportSub: "دانلود فایل JSON از پروفایل، پیشرفت و فلش‌کارت‌ها",
    exportBtn: "خروجی",
    exportDone: "✓ دانلود شد",
    cacheLabel: "حافظه موقت محلی",
    cacheSub: "پیشرفت یادگیری و جملات نمونه برای سرعت بیشتر در مرورگر ذخیره می‌شوند.",
    cookieLabel: "تنظیمات کوکی و حریم خصوصی",
    cookieSub: "تنظیمات تحلیل و کوکی در وب‌سایت Speafy مدیریت می‌شوند",
    privacyLink: "سیاست حریم خصوصی ↗",
    aboutSection: "درباره",
    aiTutorLabel: "مدرس هوش مصنوعی",
    aiTutorSub: "با Claude Sonnet — Anthropic",
    algoLabel: "الگوریتم حافظه",
    algoSub: "FSRS v4.5 — برنامه‌ریزی تکرار فاصله‌دار",
    learningSection: "یادگیری",
    placementTestLabel: "آزمون تعیین سطح",
    placementTestSubNew: "با یک آزمون کوتاه، سطح شروع خود را پیدا کنید",
    placementTestSubRetake: "آخرین سطح تعیین‌شده: {level} · هر وقت خواستید دوباره امتحان کنید",
    placementTestBtnNew: "شروع آزمون",
    placementTestBtnRetake: "تکرار آزمون",
    versionLabel: "نسخه",
    appearanceSection: "ظاهر",
    darkModeLabel: "حالت تاریک",
    darkModeSub: "تغییر به رنگ‌بندی تاریک",
    largeTextLabel: "متن بزرگ",
    largeTextSub: "افزایش اندازه متن برای خواندن راحت‌تر",
    babiCheckinsSection: "چک-این‌های بابی",
    babiDailyNudgeLabel: "یادآوری روزانه‌ی بابی",
    babiDailyNudgeSub: "بابی هر روز می‌پرسه چقدر وقت داری و یه برنامه مطالعه پیشنهاد می‌ده",
    babiWeeklyReportLabel: "گزارش هفتگی بابی",
    babiWeeklyReportSub: "خلاصه‌ی هفتگی پیشرفتت، هفته‌ای یک بار",
    dangerSection: "منطقه خطر",
    resetLabel: "بازنشانی همه پیشرفت‌ها",
    resetSub: "ریست کردن استریک، فلش‌کارت‌ها و تاریخچه درس‌ها. قابل بازگشت نیست.",
    resetBtn: "بازنشانی",
    resetConfirmP1: "همه پیشرفت‌ها بازنشانی شود؟ موارد زیر حذف می‌شوند:",
    resetConfirmC1: "همه {n} فلش‌کارت و داده‌های حافظه آن‌ها",
    resetConfirmC2: "استریک ({n} روز) و تاریخچه مطالعه",
    resetConfirmC3: "تمام سوابق تکمیل درس، در همه زبان‌هایی که یاد می‌گیری",
    resetConfirmC4: "پیشرفت مرورت در آزمایشگاه دستور زبان",
    resetConfirmP2: "حساب، نام و تنظیمات زبان حفظ می‌شوند.",
    resetConfirmBtn: "بله، همه چیز را بازنشانی کن",
    resetting: "در حال بازنشانی…",
    resetDone: "✅ پیشرفت بازنشانی شد! از نو شروع کن.",
    deleteLabel: "حذف حساب",
    deleteSub: "حساب و تمام داده‌ها را برای همیشه حذف می‌کند. قابل بازگشت نیست.",
    deleteBtn: "حذف حساب",
    deleteConfirmP1: "حساب Speafy خود را به طور دائم حذف کنید؟ موارد زیر فوری و غیرقابل بازگشت حذف می‌شوند:",
    deleteConfirmC1: "پروفایل شما (نام، زبان، اهداف)",
    deleteConfirmC2: "همه {n} فلش‌کارت و داده‌های حافظه",
    deleteConfirmC3: "تاریخچه کامل یادگیری و استریک",
    deleteConfirmC4: "حساب احراز هویت Firebase",
    deleteConfirmPrompt: "برای تأیید DELETE (با حروف بزرگ) تایپ کنید:",
    deleteConfirmBtn: "حساب من را برای همیشه حذف کن",
    deleting: "در حال حذف…",
    cancelBtn: "لغو",
  },
  search: {
    trigger: "جستجو",
    title: "🔍 جستجو",
    close: "✕ بستن",
    clear: "پاک کردن جستجو",
    placeholder: "جستجوی کلمات، موضوعات، دستور زبان…",
    emptyPrompt: "برای جستجوی کلمات، موضوعات و نکات دستوری تایپ کنید.",
    noResults: "نتیجه‌ای با \"{search}\" مطابقت ندارد",
    resultsLabel: "نتایج جستجو",
    topicsLabel: "موضوعات",
    wordsLabel: "کلمات",
    grammarLabel: "دستور زبان",
    badgeTopic: "موضوع",
    badgeWord: "کلمه",
    badgeGrammar: "دستور زبان",
    proTag: "Pro",
  },
  authAction: {
    verifyingTitle: "ایمیل شما در حال تأیید است…",
    verifiedTitle: "ایمیل شما تأیید شد!",
    verifiedBody: "همه چیز آماده است. برای ادامه یادگیری به Speafy برگردید.",
    continueBtn: "ادامه به Speafy →",
    verifyErrorTitle: "این لینک منقضی شده است",
    verifyErrorBody: "این لینک تأیید دیگر معتبر نیست. وارد شوید تا لینک جدیدی برایتان بفرستیم.",
    resendBtn: "ارسال مجدد ایمیل تأیید",
    resendSent: "ارسال شد ✓",
    resendError: "امکان ارسال مجدد نبود. لطفاً کمی بعد دوباره امتحان کنید.",
    signInBtn: "ورود",
    verifyingReset: "در حال بررسی لینک شما…",
    resetTitle: "رمز عبور خود را بازنشانی کنید",
    resetBodyFor: "یک رمز عبور جدید برای {email} انتخاب کنید",
    newPasswordPh: "رمز عبور جدید",
    confirmPasswordPh: "تأیید رمز عبور جدید",
    resetSubmitBtn: "بازنشانی رمز عبور",
    resettingBtn: "در حال بازنشانی…",
    resetSuccessTitle: "رمز عبور به‌روزرسانی شد!",
    resetSuccessBody: "رمز عبور شما تغییر کرد. با رمز عبور جدید وارد شوید.",
    resetErrorTitle: "این لینک منقضی شده است",
    resetErrorBody: "این لینک بازنشانی رمز عبور دیگر معتبر نیست. از صفحه ورود یک لینک جدید درخواست کنید.",
    passwordMismatch: "رمزهای عبور یکسان نیستند.",
    passwordTooShort: "رمز عبور باید حداقل ۶ کاراکتر باشد.",
    genericError: "مشکلی پیش آمد. لطفاً دوباره امتحان کنید.",
    invalidTitle: "این لینک نامعتبر است یا منقضی شده",
    invalidBody: "لینکی که دنبال کردید دیگر معتبر نیست. لطفاً به Speafy برگردید و دوباره امتحان کنید.",
    backToSignIn: "بازگشت به صفحه ورود",
  },

  // Teacher-partner affiliate disclosure — FINALIZED wording, do not edit/re-translate.
  // `reviewed: false` → a native speaker flips it to `true` after confirming. See strings.js.
  affiliate: {
    disclosure: {
      text: "یک نکته‌ی کوچک: اگر از طریق لینک من در اسپیفای ثبت‌نام کنید، من کارمزد کمی دریافت می‌کنم؛ این هیچ هزینه‌ی اضافه‌ای برای شما ندارد.",
      reviewed: false,
    },
    // Promo message — FINALIZED + native-verified. `{{referral_link}}` is a literal placeholder. See strings.js.
    promoTemplate: {
      text: "سلام به همه! یک اپلیکیشن بهتون معرفی می کنم که مکمل خوبی برای کلاس‌های ما هست: اسپیفای. این اپلیکیشن دقیقاً همان موضوعاتی را دنبال می‌کنه که من با شما کار می کنم، و شما می‌تونید هر وقت بخواهید با یک ایجنت هوش مصنوعی اختصاصی به نام بابی تمرین صحبت‌کردن داشته باشید. ثبت نام اون رایگانه و من هر هفته گزارشی از پیشرفت شما دریافت می‌کنم تا ببینم بین جلسات ما چطور پیش میرید. از این لینک ثبت‌نام کنید تا به‌عنوان معلم شما به من متصل بشید: {{referral_link}}",
      reviewed: true,
    },
  },

  teacherDash: {
    link: "داشبورد معلم",
    title: "داشبورد معلم",
    backHome: "بازگشت به خانه",
    studentBadge: "معلم شما: {name}",
    intro: "هر چیزی که برای آوردن زبان‌آموزانتان به Speafy و پیگیری پیشرفتشان لازم دارید.",
    referralTitle: "لینک معرفی شما",
    referralBody: "این لینک را با زبان‌آموزانتان به اشتراک بگذارید. هر کسی که از طریق آن ثبت‌نام کند، به‌عنوان معلمش به شما پیوند می‌خورد.",
    copy: "کپی لینک",
    copied: "کپی شد",
    shareText: "به من در Speafy بپیوند و بیا با هم یک زبان یاد بگیریم! {link}",
    shareTelegramText: "به من در Speafy بپیوند و بیا با هم یک زبان یاد بگیریم!",
    shareEmailSubject: "به من در Speafy بپیوند",
    shareWhatsapp: "واتس‌اپ",
    shareTelegram: "تلگرام",
    shareEmail: "ایمیل",
    shareSms: "پیامک",
    shareMore: "بیشتر",
    studentsTitle: "زبان‌آموزان شما",
    studentsLoading: "در حال بارگذاری زبان‌آموزان شما…",
    studentsError: "در حال حاضر نتوانستیم زبان‌آموزان شما را بارگذاری کنیم.",
    retry: "تلاش دوباره",
    studentsEmpty: "هنوز زبان‌آموزی ندارید. لینک معرفی خود را به اشتراک بگذارید — زبان‌آموزانی که از طریق آن ملحق شوند اینجا نمایش داده می‌شوند.",
    colName: "زبان‌آموز",
    colJoined: "تاریخ عضویت",
    colStatus: "اشتراک",
    colCommission: "کمیسیون کسب‌شده",
    colGrammar: "تمرکز دستوری",
    statusActive: "فعال",
    statusTrial: "آزمایشی",
    statusNone: "بدون اشتراک",
    commissionNote: "این مجموع درآمدی است که از هر دانش‌آموز به دست آورده‌اید. موجودی قابل برداشت شما در پایین نشان داده شده است.",
    commissionCapReached: "دورهٔ ۱۲ ماهه به پایان رسید",
    grammarNote: "داده‌های اشتباهات دستوری فقط برای دانش‌آموزانی که اشتراک فعال دارند نمایش داده می‌شود.",
    studentUnnamed: "زبان‌آموز",
    curriculumTitle: "مرجع برنامهٔ درسی",
    curriculumBody: "همهٔ موضوع‌ها و واژه‌هایی را که زبان‌آموزانتان یاد می‌گیرند، به‌ترتیب مرور کنید.",
    curriculumLink: "باز کردن مرجع برنامهٔ درسی",
    profileTitle: "نمایهٔ معلمی شما",
    profileBody: "پس از راه‌اندازی فهرست معلمان Speafy، این‌گونه در آن دیده خواهید شد.",
    profileBio: "معرفی کوتاه",
    profileBioPh: "یک یا دو جمله دربارهٔ خودتان و شیوهٔ تدریستان.",
    profilePhoto: "عکس",
    photoChoose: "انتخاب عکس",
    photoUploading: "در حال آپلود…",
    photoRemove: "حذف",
    photoHint: "PNG یا JPG، حداکثر ۲۰۰ کیلوبایت.",
    photoTypeErr: "لطفاً یک تصویر PNG یا JPG انتخاب کنید.",
    photoSizeErr: "این تصویر بیش از ۲۰۰ کیلوبایت است — لطفاً تصویر کوچک‌تری انتخاب کنید.",
    photoUploadErr: "آپلود ناموفق بود. لطفاً دوباره امتحان کنید.",
    profileLink: "وب‌سایت شخصی یا لینک شبکهٔ اجتماعی",
    profileLinkPh: "www.example.com",
    profileLanguages: "زبان‌هایی که تدریس می‌کنم",
    profileLanguagesHint: "زبان‌هایی را که تدریس می‌کنید انتخاب کنید. با افزوده‌شدن زبان‌های تازه به دوره‌های Speafy، گزینه‌های بیشتری فعال می‌شود.",
    profileLanguagesSoon: "به‌زودی",
    save: "ذخیره",
    saving: "در حال ذخیره…",
    saved: "ذخیره شد",
    urlError: "این به نظر یک نشانی وب نمی‌رسد. آن را بررسی کنید یا فیلد را خالی بگذارید.",
    termsStatusAccepted: "شرایط همکاری معلم — پذیرفته‌شده در {date}",
    termsStatusPending: "شرایط همکاری معلم — هنوز پذیرفته نشده",
    termsVersionLabel: "نسخهٔ {version}",
    termsView: "مشاهدهٔ شرایط پذیرفته‌شده",
    payoutTitle: "برداشت",
    payoutLoading: "در حال بارگذاری وضعیت برداشت شما…",
    payoutError: "اکنون نتوانستیم وضعیت برداشت شما را بارگذاری کنیم.",
    payoutBalance: "موجودی فعلی شما: {balance}",
    payoutNotEligible: "وقتی موجودی شما به {threshold} برسد، می‌توانید درخواست برداشت بدهید.",
    payoutAlreadyRequested: "درخواست برداشت ثبت شد — با شما تماس خواهیم گرفت.",
    requestPayoutBtn: "درخواست برداشت",
    payoutRequestFailed: "در ارسال درخواست شما مشکلی پیش آمد. لطفاً دوباره امتحان کنید.",
    payoutConfirmTitle: "درخواست برداشت؟",
    payoutConfirmBody: "شما در حال حاضر {balance} برای درخواست در دسترس دارید.\n\nاین کار یک فرایند برداشت دستی را آغاز می‌کند — هیچ پولی به‌طور خودکار جابه‌جا نمی‌شود. درخواست شما را بررسی می‌کنیم و از طریق ایمیل با شما در تماس خواهیم بود.",
    payoutConfirmBtn: "درخواست برداشت",
    payoutConfirmCancel: "انصراف",
  },

  teacherTerms: {
    screenTitle: "شرایط همکاری معلم",
    contents: "فهرست",
    lastUpdatedLabel: "آخرین به‌روزرسانی",
    effectiveLabel: "تاریخ اجرا",
    bannerTitle: "نیازمند اقدام",
    bannerBody: "برای ادامهٔ همکاری، لطفاً شرایط همکاری معلم را بخوانید و بپذیرید.",
    bannerCta: "بررسی و پذیرش",
    acceptedOn: "شما این شرایط را در {date} پذیرفتید.",
    acceptedVersion: "نسخهٔ پذیرفته‌شده: {version}",
    accepting: "در حال ثبت پذیرش شما…",
    acceptError: "در حال حاضر نتوانستیم پذیرش شما را ثبت کنیم. لطفاً دوباره تلاش کنید.",
    draftNotice: "این شرایط هنوز نهایی نشده است. پس از تعیین تاریخ اجرا می‌توانید آن را بپذیرید.",
  },
};

export default fa;
